import { ReactComponent as SetupIcon } from "../../../svgs/add-icon.svg";
import { ReactComponent as UploadIcon } from "../../../svgs/upload.svg";
import { ReactComponent as ApprovalIcon } from "../../../svgs/comment-check.svg";
import { ReactComponent as ReportIcon } from "../../../svgs/edit.svg";
import { ReactComponent as ProfileIcon } from "../../../svgs/user.svg";
import { ReactComponent as SettingsIcon } from "../../../svgs/settings.svg";
import { ReactComponent as LockIcon } from "../../../svgs/lock.svg";
import { ReactComponent as GenerateIcon } from "../../../svgs/generate.svg";
// import { ReactComponent as TranscriptIcon } from "../../../svgs/transcript.svg";

export interface Path {
  title: string;
  path: string;
}

export interface NavProps {
  title: string;
  icon: React.ReactNode;
  subNav?: Path[];
  path?: string;
  roles?: string[];
}

export const sidebarData: NavProps[] = [
  {
    title: "Setup",
    roles: ["Admin"],
    icon: <SetupIcon />,
    subNav: [
      {
        title: "Users",
        path: "/users",
      },
      {
        title: "Faculties",
        path: "/directorates",
      },
      {
        title: "Departments",
        path: "/departments",
      },
      {
        title: "Courses",
        path: "/courses",
      },
      {
        title: "Students",
        path: "/students",
      },
    ],
  },
  {
    title: "Upload",
    roles: ["Lecturer"],
    icon: <UploadIcon />,
    path: "/upload",
  },
  {
    title: "Approval",
    roles: ["Admin", "Exam Officer"],
    icon: <ApprovalIcon />,
    subNav: [
      {
        title: "Approve Results",
        path: "/approve-results",
      },
      {
        title: "View Results",
        path: "/view-results",
      },
      {
        title: "View Current Results",
        path: "/view-current-results",
      },
      {
        title: "View Master Results",
        path: "/view-master-results",
      },
      {
        title: "Session Summary Result",
        path: "/session-summary-result",
      },
      {
        title: "View Master Results Export",
        path: "/view-master-results-export",
      },
      {
        title: "Final Result Summary",
        path: "/final-result-summary",
      },
      {
        title: "Result Spreadsheet",
        path: "/result-spreadsheet",
      },
      {
        title: "Result KPI",
        path: "/result-kpi",
      },
      {
        title: "Result KPI Schedule",
        path: "/result-kpi-schedule",
      },
    ],
  },
  {
    title: "Report",
    icon: <ReportIcon />,
    subNav: [
      {
        title: "Pending Upload",
        path: "/pending-upload",
      },
      {
        title: "Pending Approval",
        path: "/pending-approval",
      },
      {
        title: "Approved Results",
        path: "/approved-results",
      },
      {
        title: "Cumulative Results",
        path: "/cumulative-results",
      },
    ],
  },
  {
    title: "Generate",
    icon: <GenerateIcon />,
    path: "/generate-student-score",
    roles: ["Admin", "Lecturer"],
  },
  {
    title: "Generate Certificate",
    icon: <GenerateIcon />,
    // path: "/generate-certificate",
    roles: ["Admin"],
    subNav: [
      // {
      //   title: "Graduating List",
      //   path: "/graduant-list",
      // },
      {
        title: "Pending Certificate",
        path: "/pending-certificate",
      },
      {
        title: "Processed Certificate",
        path: "/processed-certificate",
      },
    ],
  },
  {
    title: "Profile",
    icon: <ProfileIcon />,
    path: "/profile",
  },
];

export const sidebarEndData: NavProps[] = [
  {
    title: "Configure",
    roles: ["Admin"],
    icon: <SettingsIcon />,
    path: "/session",
  },
  // {
  //   title: "Transcript",
  //   roles: ["Admin"],
  //   icon: <TranscriptIcon />,
  //   subNav: [
  //     {
  //       title: "Requests",
  //       path: "/requests",
  //     },
  //     {
  //       title: "Graduants",
  //       path: "/graduant-list",
  //     },
  //     {
  //       title: "Generate",
  //       path: "/generate-transcript",
  //     },
  //     {
  //       title: "Setup",
  //       path: "/setup-transcript",
  //     },
  //     {
  //       title: "Admin Users",
  //       path: "/transcript-admin-users",
  //     },
  //     {
  //       title: "Report",
  //       path: "/transcript-report",
  //     },
  //     {
  //       title: "Audit Trail",
  //       path: "/audit-trail",
  //     },
  //   ],
  // },
  {
    title: "Change Password",
    icon: <LockIcon />,
    path: "/reset-password",
  },
];